import moment from "moment";
import _ from "lodash";
import request from "@/method/request";
import { data1_3_default } from './data';
import { message } from "antd";

export const fillData = (data, data1) => {
    let index = [5, 6, 7, 8, 10, 12, 14, 16, 18, 19, 22];
    index.forEach((item, i) => {
        if (i >= 4 && i <= 8) {
            data[i].mtd_percent = data1[item].actual;
            data[i].ytd_percent = data1[item].year_actual;
            data[i].threemonth_percent = data1[item].three_actual;
            data[i].wholeyear_budget_percent = data1[item].whole_actual_budget;
            data[i].wholeyear_lastyear_percent = data1[item].whole_actual_last_year;
        } else {
            data[i].mtd_percent = data1[item].actual_prediction;
            data[i].ytd_percent = data1[item].year_actual_last_year;
            data[i].threemonth_percent = data1[item].three_actual_last_year;
            data[i].wholeyear_budget_percent = data1[item].whole_actual_budget;
            data[i].wholeyear_lastyear_percent = data1[item].whole_actual_last_year;
        }
    })
    return data
}

export const saveAllData = async (date) => {
    // 获取所有酒店
    const { data: { hotels } } = await request('/getHotels');
    for (let i = 0; i < hotels.length; i++) {
        const item = hotels[i];
        //  获取当前酒店数据 
        let data = _.cloneDeep(data1_3_default);
        const { data: x } = await request(`/_1_3?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}&comid=${item.id}`);
        if (x.data && x.data.length > 0) {
            data = x.data;
        }
        data = fillData(data, x.kpis);
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let _data = data.map(x => ({ ...x, year, month, comid: item.id }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(_data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        };
        await request('/add_1_3', headres);
    }
    message.success('保存成功！');
}


// WEBPACK FOOTER //
// ./src/components/table/1-KPI/1-3/compute.js